export default __webpack_public_path__ + "static/IN-9408v9008_resTestBig2-8c2705920c2cda0f95d2426f1a39711c.webp";